// Videos im Abschnitt "STYA Video-Erklaerungen":
// laden erst beim Heranscrollen und pausieren wieder, sobald sie aus dem Bild sind.

const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

function activate(video) {
  if (video.dataset.styaVtReady === 'true') return;
  video.dataset.styaVtReady = 'true';
  video.querySelectorAll('source[data-src]').forEach((source) => {
    source.src = source.dataset.src;
  });
  video.load();
}

function setup(root) {
  const scope = root && root.querySelectorAll ? root : document;
  const videos = scope.querySelectorAll('video[data-stya-vt-lazyvideo]:not([data-stya-vt-observed])');
  if (!videos.length) return;

  videos.forEach((video) => {
    video.dataset.styaVtObserved = 'true';
  });

  if (REDUCED.matches) {
    videos.forEach(activate);
    return;
  }

  if (!('IntersectionObserver' in window)) {
    videos.forEach((video) => {
      activate(video);
      video.play().catch(() => {});
    });
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting) {
          activate(video);
          video.play().catch(() => {});
        } else if (!video.paused) {
          video.pause();
        }
      });
    },
    { rootMargin: '200px 0px' }
  );

  videos.forEach((video) => observer.observe(video));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => setup());
} else {
  setup();
}

document.addEventListener('shopify:section:load', (event) => setup(event.target));
